module.exports = __webpack_public_path__ + "bfb66b85f31eae9f749a0162d677fdf2.MP3";